import React from 'react';
import { motion } from 'framer-motion';
import { Users, Wallet, CreditCard, CheckCircle2, ClockIcon } from 'lucide-react';
const steps = [{
  icon: <Users className="w-6 h-6 text-kitty-dark" data-id="element-139" />,
  title: 'Add money to the kitty',
  description: 'Everyone chips in upfront. Apple Pay, Google Pay, or bank card.'
}, {
  icon: <Wallet className="w-6 h-6 text-kitty-dark" data-id="element-140" />,
  title: 'Spend together or log expenses',
  description: 'Pay as you normally would and log it in the app. Easy.'
}, {
  icon: <CreditCard className="w-6 h-6 text-kitty-dark" data-id="element-141" />,
  title: 'We track everything',
  description: 'Every payment is logged in real time. No spreadsheets needed.'
}, {
  icon: <CheckCircle2 className="w-6 h-6 text-kitty-dark" data-id="element-142" />,
  title: "Everyone gets back what they're owed",
  description: 'Close the pot and balances settle automatically.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-28 lg:py-36 bg-white" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-145">
          <div className="inline-flex bg-kitty-yellow-100 text-kitty-yellow-800 rounded-full px-3 py-1 text-xs font-semibold mb-4" data-id="element-146">
            How it works
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-147">
            How KittyPot works
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto mb-3" data-id="element-148">
            Unlike splitting apps, everyone adds money upfront. KittyPot
            balances everything automatically.
          </p>
          <p className="text-sm font-semibold text-kitty-dark/50 mb-5" data-id="element-149">
            No chasing. No spreadsheets. No stress.
          </p>
          <div className="inline-flex items-center gap-1.5 text-sm text-gray-400 font-medium" data-id="element-150">
            <ClockIcon className="w-4 h-4" data-id="element-151" />
            Set up in under 30 seconds
          </div>
        </div>

        <div className="relative" data-id="element-152">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0 border-t-2 border-dashed border-kitty-yellow-200 -z-10" data-id="element-153"></div>

          <div className="grid md:grid-cols-4 gap-8 md:gap-4" data-id="element-154">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative flex flex-col items-center text-center group" data-id="element-155">
                <div className="w-24 h-24 rounded-3xl bg-kitty-yellow-50 flex items-center justify-center mb-6 group-hover:bg-kitty-yellow-100 transition-colors relative shadow-sm border border-kitty-yellow-100" data-id="element-156">
                  {/* Number badge */}
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-kitty-yellow text-kitty-dark font-bold flex items-center justify-center border-4 border-white shadow-sm" data-id="element-157">
                    {index + 1}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold text-kitty-dark mb-2" data-id="element-158">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed px-2" data-id="element-159">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}